import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import { CandidateBuilder } from '../candidates.types';

export const updateCandidateOpenToWork = (builder: CandidateBuilder) =>
  builder.mutation<any, any>({
    query: ({ CandidateId, OpenToWork }) => ({
      url: `/candidates/open-to-work/${CandidateId}`,
      method: 'PATCH',
      body: { OpenToWork },
    }),
    transformResponse: (queryResponse: { data: any }) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.UpdateCandidate
          : SuccessMessageEn.UpdateCandidate,
        true
      );
      return queryResponse.data;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[uploadCandidateInfoAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.UpdateCandidateFail
          : ErrorMessageEn.UpdateCandidatesFail,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (res, meta, arg) => [
      { type: 'Candidate', Id: arg.CandidateId },
    ],
  });
